module.exports = __webpack_public_path__ + "img/logo.0290c466.jpg";